import * as types from './action_types';
import DateMaster from '../utils/date_master';
import TackNotificationsService from '../../services/tack_notifications_service';
import * as TackNotificationsActions from '../tack_notifications/actions';

export const reset = () => {
  return { type: types.TACK_NOTIFICATION_DETAILS_RESET };
}

export const fetch = (slug) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_NOTIFICATION_DETAILS_RETRIEVING });
      const tackNotificationDetailsData = await TackNotificationsService.tackNotificationDetails(slug);
      const tackNotificationDetails = {
        wordText: tackNotificationDetailsData.word_text,
        partOfSpeech: tackNotificationDetailsData.part_of_speech,
        tacksCount: tackNotificationDetailsData.tacks_count,
        tackInterval: tackNotificationDetailsData.tack_interval,
        day: tackNotificationDetailsData.day,
        pronunciationFile: tackNotificationDetailsData.pronunciation_file,
        exampleText: tackNotificationDetailsData.example_text,
        definitions: tackNotificationDetailsData.definitions,
        recommendedWords: tackNotificationDetailsData.recommended_words,
        mnemonicImageUrl: tackNotificationDetailsData.mnemonic_image_url,
        isCheckpoint: tackNotificationDetailsData.is_checkpoint,
        isChat: tackNotificationDetailsData.is_chat,
        isReadyForSynonyms: tackNotificationDetailsData.is_ready_for_synonyms,
        isArchive: tackNotificationDetailsData.is_archive,
        lastSentDate: DateMaster.parseUTC(tackNotificationDetailsData.last_sent_date),
        readAt: DateMaster.parseUTC(tackNotificationDetailsData.read_at),
        slug: tackNotificationDetailsData.slug,
        tackSlug: tackNotificationDetailsData.tack_slug,
        deliveryMethod: tackNotificationDetailsData.delivery_method,
        createdAt: DateMaster.parseUTC(tackNotificationDetailsData.created_at)
      }
      dispatch({ type: types.TACK_NOTIFICATION_DETAILS_RETRIEVED, tackNotificationDetails });
    } catch(error) {
      dispatch({ type: types.TACK_NOTIFICATION_DETAILS_ERROR, error });
    }
  }
}

export const markAsRead = (slug) => {
  return async(dispatch) => {
    try {
      await TackNotificationsService.markAsRead(slug);
      dispatch(TackNotificationsActions.unreadCount());
      dispatch({ type: types.TACK_NOTIFICATION_DETAILS_MARKED_AS_READ });
    } catch(error) {
      dispatch({ type: types.TACK_NOTIFICATION_DETAILS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack_notification_details/actions.js